import { Component, OnInit } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { NetworkService } from 'src/app/angular-wallet-base/services/network.service';
import { openLinkExternal } from 'src/app/angular-wallet-base/utils';
interface SuccessModalData {
  token_info: any;
  amount: string;
  from_network: string;
  to_network: string;
  tranId: string;
}
@Component({
  selector: 'success-move',
  templateUrl: './success-move-modal.html',
  styleUrls: ['./success-move-modal.scss']
})
export class SuccessMoveComponent implements OnInit {

  public isDesktopMode;
  public successModalData: SuccessModalData;
  constructor(
    public appMode: AppModeService,
    private modalController: ModalController,
    private networkService: NetworkService,
    public actionSheetController: ActionSheetController,
    private inAppBrowser: InAppBrowser,
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() {
  }

  async closeModal(backToHome: boolean) {
    await this.modalController.dismiss({backToHome: backToHome}, '', 'successMoveModal');
  }

  async backToHome() {
    await this.closeModal(true);
  }

  async backToMovePage() {
    await this.closeModal(false);
  }

  async openBlockExplorer() {
    const activeNetwork = await this.presentActionSheet();
    openLinkExternal(`${activeNetwork.URL}/tx/${this.successModalData.tranId}`, this.inAppBrowser);
  }

  async presentActionSheet() {
    let activeNetwork;
    switch (this.successModalData.from_network) {
      case 'SYS':
        return activeNetwork = await this.networkService.getActiveSysNetwork();
      case 'ETH':
        return activeNetwork = await this.networkService.getActiveEthNetwork();
      case 'BTC':
        return activeNetwork = await this.networkService.getActiveBtcNetwork();
      case 'AVAX':
        activeNetwork = await this.networkService.getActiveAvaxNetwork();
        activeNetwork.URL = activeNetwork.API_EXPLORER;
        return activeNetwork;
      default:
        break;  
    }
  }
}
